import React from 'react';
import { BannerContainer, ImgContainer } from './styles';
import AppStoreComponent from '../LandingPage/AppStore';
import DianaBannerRiva from '../../assets/diana/riva/Diana-Banner-Download.png';
import DianaBannerDirecional from '../../assets/diana/direcional/Diana-Banner-Download.png';

const BannerDownloadApp = ({ tema }) => {
  const imgBannerSrc =
    tema.tipo === 'Direcional' ? DianaBannerDirecional : DianaBannerRiva;
  console.log(tema);
  return (
    <BannerContainer color={tema?.primaryColor}>
      <div className='textContainer'>
        <div>
          <p className='title-text'>
            <b>
              Olá, eu sou a Diana, assistente virtual do Grupo Direcional, muito
              prazer!
            </b>
          </p>
          <p>
            Vou acompanhar sua jornada aqui no{' '}
            <span className='podemorarText'>Pode Morar.</span> Já baixou nosso
            aplicativo?
          </p>
        </div>
        <div className='container-diana-download'>
          <AppStoreComponent primaryColor={tema?.primaryColor} />
        </div>
      </div>
      <ImgContainer>
        <img src={imgBannerSrc} alt='Pode Morar' />
      </ImgContainer>
    </BannerContainer>
  );
};

export default BannerDownloadApp;
